export enum ClaimTypesEnum {
  PHONE = 'phone',
  ACTIVE = 'active',
  MPI_ID = 'id_mpi',
  TWO_FACTOR_ENABLED = "two_factor_enabled",
  DATE_OF_BIRTH = "date_of_birth",
  SCHOOL_SYNLAB_ID = "school_synlab_id",
  ILIS_CODE = "ilis_code",
  GENEPLANET_USER = "geneplanet_user",
  ANONYMOUS_USER = "anonymous_user",
  FAMILY_NAME = "family_name",
  GIVEN_NAME = "given_name",
  ALLOW_DELETE_USER = "allow_delete_user",
  LOCALE = "locale",
  LOGIN_METHOD = "login_method",
  SYNLAB_ID = "synlab_id",
  COUNTRY_STORAGE = "country",
  PASSPORT_NUMBER = "passport_number",
  COUNTRY_RESIDENCE = "country_residence",
  NATIONALITY = "nationality",
  EE_NOTIFICATION_LANGUAGE = "ee_notification_language",
  SSN = "ssn",
  EMAIL = "email",
  EMAIL_VERIFIED = "email_verified",
  NO_EMAIL = "no_email",
  USER_TYPE = "user_type",
  USERID = "userId",
  CONTACT_EMAIL = "contact_email"
}
